import { useState, useEffect } from "react";
import { useIntl } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { alpha, Button, InputBase, Box } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useSearchModal } from "../../../hooks";
import {
  setSearchResults,
  setSearchQuery,
} from "../../../actions";
import { borderRadius, padding, useTheme } from "@mui/system";

const useStyles = makeStyles(theme => ({
  zoomIcon: {
    color: theme.palette.common.white,
  },
}));

const SearchWidget = ({ searchQuery,
  siteId,
  setSearchResults,
  setSearchQuery }) => {

  const search = useSearchModal();
  const intl = useIntl();
  var theme = useTheme();

  const classes = useStyles();

  const handleKeyDown = e => {
    if (e.key === "Enter") {
      initiateSearch();
    }
  };

  const initiateSearch = () => {
    setSearchQuery({ searchQuery: searchText });
    search.open();
  };

  const [searchText, setSearchText] = useState(searchQuery);

  useEffect(() => {
    if (siteId && siteId !== 0) {
      setSearchResults({});
    }
  }, [siteId]);



  return (<Box sx={{ padding: "1em", height: "100%" }}><Box sx={{ display: "flex", width: "100%", height: "100%", border: "solid 1px lightgray", borderRadius: "6px" }}>
    <InputBase onChange={e => setSearchText(e.target.value)}
      placeholder={intl.formatMessage({ id: "nav.search" })}
      value={searchText}

      sx={{
        flexGrow: 1,
        flexShrink: 1,
        width: "100%",
        padding: "0.5rem 1rem",
        backgroundColor: theme => alpha(theme.palette.common.white, 0.15),
        borderRadius: "4px 0 0 4px",
      }}

      onKeyDown={handleKeyDown} />
    <Button
      sx={{
        borderRadius: "0 4px 4px 0",
        minWidth: "48px",
        padding: "0 16px",
        backgroundColor: theme.palette.component.homeMainColor,
        '&:hover': {
          backgroundColor: alpha(theme.palette.component.homeMainColor, 0.85),
        },
      }}
      onClick={initiateSearch}
    >
      <i className={`nc-icon nc-zoom-split ${classes.zoomIcon}`} />
    </Button>

  </Box></Box>);
}

const mapStateToProps = state => {
  return {
    searchDetails: state.ui.toggleDetails,
    searchQuery: state.ui.toggleDetails.searchQuery
  };
};


const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      setSearchResults,
      setSearchQuery,
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchWidget);
